/* tslint:disable */

/**
 */
export class ReceiptSummary {
    price?: string;
    quantily?: number;
    total_price?: number;
}
